import * as actionTypes from './types';
import { endpoints } from '../../../api/endpoints';
import * as api from '../../../api/base';
import store from '../..';
import queryString from 'query-string';
import {
  dfltSuccessResponseAction,
  dfltFailResponseAction,
  dfltExceptionResponseAction
} from '../../utility'

export const setAdminFarmId = (farmId) => {
    return {
        type: actionTypes.SET_ADMIN_FARM_ID,
        payload: farmId
    };
};

export const getAllFarms = (params) => async (dispatch) => {
    const response = await api.get(endpoints.admin.farm.farms.concat('?', queryString.stringify(params)));
    if (response && response.status === 200) {
        return dispatch(getAllFarmsSuccess(response.data));
    }
    else {
        dispatch(getAllFarmsFail());
        return dispatch(dfltFailResponseAction(response));
    }
};

const getAllFarmsSuccess = (response) => {
    return {
        type: actionTypes.GET_ALL_FARMS_SUCCESS,
        payload: response
    };
};

const getAllFarmsFail = () => {
    return {
        type: actionTypes.GET_ALL_FARMS_FAIL,
    };
};

export const getAdminFarm = (farmId) => async (dispatch) => {
    try {
        const response = await api.get(endpoints.admin.farm.farm.concat('?farmId=', farmId));
        if (response && response.status === 200) {
            const { farmOwnerUserId } = response.data;
            dispatch((getAdminFarmOwnerData(farmOwnerUserId)))
            return dispatch(getAdminFarmSuccess(response.data));
        }
        else {
            return dispatch(dfltFailResponseAction(response));
        }
    } catch (e) {
        return dispatch(dfltExceptionResponseAction(e));
    }
};

const getAdminFarmSuccess = (response) => {
    return {
        type: actionTypes.GET_ADMIN_FARM_DATA_SUCCESS,
        payload: response
    };
};

export const getAdminFarmOwnerData = (accountId) => async (dispatch) => {
    const response = await api.get(endpoints.admin.user.account.concat(accountId));
    if (response && response.status === 200) {
        return dispatch(getAdminFarmOwnerDataSuccess(response.data));
    }
    else {
        return dispatch(dfltFailResponseAction(response));
    }
};

const getAdminFarmOwnerDataSuccess = (response) => {
    return {
        type: actionTypes.GET_ADMIN_FARM_OWNER_DATA_SUCCESS,
        payload: response
    };
};

export const createAdminFarm = (data) => async (dispatch) => {

    try {
        const response = await api.post(endpoints.admin.farm.farm,
            {
                farmName: data?.farmName,
                holdingNumber: data?.holdingNumber,
                businessReferenceNumber: data?.businessReferenceNumber,
                addressLine1: data?.addressLine1,
                addressLine2: data?.addressLine2,
                townCity: data?.townCity,
                countryId: data?.countryId,
                zipPostCode: data?.zipPostCode,
                isFarmAdvisoryService: data?.isFarmAdvisoryService,
                farmOwnerUserId: data?.farmOwnerUserId,
                organizationId: data?.organisationId || null,
                officeId: data?.officeId || null,
                license: data?.license,
                externalFarmId: data?.externalFarmId,
                licenseStartDate: data?.licenseStartDate,
                licenseEndDate: data?.licenseEndDate

            }
        );
        if (response && response.status === 200) {
            return dispatch(dfltSuccessResponseAction("Farm has been created successfully."));
        }
        else {
            return dispatch(dfltFailResponseAction(response));
        }
    } catch (e) {
        return dispatch(dfltExceptionResponseAction(e));
    }
};


export const updateAdminFarm = (data) => async (dispatch) => {
    try {
        const response = await api.put(endpoints.admin.farm.farm,
            {
                id: data?.id,
                farmName: data?.farmName,
                holdingNumber: data?.holdingNumber,
                businessReferenceNumber: data?.businessReferenceNumber,
                addressLine1: data?.addressLine1,
                addressLine2: data?.addressLine2,
                townCity: data?.townCity,
                countryId: data?.countryId,
                zipPostCode: data?.zipPostCode,
                isFarmAdvisoryService: data?.isFarmAdvisoryService,
                farmOwnerUserId: data?.farmOwnerUserId,
                organizationId: data?.organisationId || null,
                officeId: data?.officeId || null,
                license: data?.license,
                externalFarmId: data?.externalFarmId,
                licenseStartDate: data?.licenseStartDate,
                licenseEndDate: data?.licenseEndDate            }
        );

        if (response && response.status === 200) {
            return dispatch(dfltSuccessResponseAction("Farm has been successfully updated"));
        }
        else {
            return dispatch(dfltFailResponseAction(response));
        }
    } catch (e) {
        return dispatch(dfltExceptionResponseAction(e));
    }
}

export const deleteAdminFarm = () => async (dispatch) => {
    const { farmId } = store.getState().adminFarm;
    const response = await api.del(endpoints.admin.farm.farm.concat('?farmId=', farmId));
    if (response && (response.status === 200 || response.status === 204)) {
        return dispatch(dfltSuccessResponseAction(response.data || "The Farm has been successfully deleted"));
    }
    else {
        return dispatch(dfltFailResponseAction(response));
    }
};




